import { RootState } from "../..";
import { StockAnalysisData } from "./types";
export const selectAIAnalysisData = (state: RootState): StockAnalysisData => state.user.aiAnalysis.data;
export const selectAIAnalysisDataLoading = (state: RootState):boolean => state.user.aiAnalysis.loading;
